<template>
    <div class="login">
        <default v-if="showDesktop">
            <template slot="content">
                <div class="form-con">
                    <h1>{{ 'Login' | translate }}</h1>
                    <div class="wrapper">
                        <form autocomplete="off" @submit.prevent="login">
                            <div class="form-group">
                                <label>{{ 'Enter username or Email' | translate }}</label>
                                <div class="input-wrapper">
                                    <input class="form-control" type="text" :placeholder="'Username' | translate" v-model="email_or_nick.val" @blur="checkEmptyEmail($event, 'email_or_nick')">
                                </div>
                                <div v-if="email_or_nick.error_msg" class="error-msg-con">
                                    <i class="fa fa-exclamation-triangle"></i> {{ 'Enter username or Email' | translate }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label>{{ 'Password' | translate}}</label>
                                <div class="input-wrapper with-icon">
                                    <input class="form-control" :type="password_input_type" :placeholder="'Password' | translate" v-model="password.val">
                                    <i :class="`icon icon-eye ${password_input_type != 'password' ? 'active' : ''}`" @click="changePasswordInputType"></i>
                                </div>
                                <div v-if="password.error_msg" class="error-msg-con">
                                    <i class="fa fa-exclamation-triangle"></i> {{ 'Enter Password' | translate }}
                                </div>
                            </div>
                            <div class="forgot-pass-con">
                                <a href="" @click.prevent="openForgotPass">{{ 'I forgot my password' | translate }}</a>
                            </div>
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <button class="btn btn-primary">
                                        <span>{{ 'Login' | translate | capitalize }}</span>
                                    </button>
                                    <template v-if="oauthProviders.length">
                                        <p class="divider">{{ 'OR' | translate }}</p>
                                        <button :class="`btn btn-${provider}-oauth`" @click.prevent="redirectOauth(provider)" v-for="provider in oauthProviders" :key="provider">
                                            <i :class="`icon icon-${provider}`"></i>
                                            <span class="icon-bg"></span>
                                            <span>{{ `Connect with ${capitalize(provider)}` | translate }}</span>
                                        </button>
                                        <div v-if="hasProviderError" :class="`error-msg-con ${provider}-connect`">
                                            <i class="fa fa-exclamation-triangle"></i>{{ 'This email address is not registered, please sign up to log in.' | translate }}
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div v-if="error_all" class="form-group error-all">
                                <div class="input-wrapper">
                                    <div class="error-msg-con multiple">
                                        <span><i class="fa fa-exclamation-triangle"></i>{{ 'Login failed' | translate }}</span>
                                        <p>{{ 'Username or password is incorrect' | translate }}</p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </template>
        </default>
        <div v-if="!showDesktop" class="form-con mobile">
            <i class="icon icon-close" @click="$router.push({name:'home'})"></i>
            <div class="wrapper">
                <h1>{{ 'LOGIN USING YOUR CREDENTIALS' | translate }}</h1>
                <form autocomplete="off" @submit.prevent="login">
                    <div class="form-group">
                        <div class="input-wrapper">
                            <input class="form-control" type="text" :placeholder="'Username' | translate" v-model="email_or_nick.val">
                        </div>
                        <div v-if="email_or_nick.error_msg" class="error-msg-con">
                            <i class="fa fa-exclamation-triangle"></i> {{ 'Enter username or Email' | translate }}
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="input-wrapper with-icon">
                            <input class="form-control" :type="password_input_type" :placeholder="'Password' | translate" v-model="password.val">
                            <i :class="`icon icon-eye ${password_input_type != 'password' ? 'active' : ''}`" @click="changePasswordInputType"></i>
                        </div>
                        <div v-if="password.error_msg" class="error-msg-con">
                            <i class="fa fa-exclamation-triangle"></i> {{ 'Enter Password' | translate }}
                        </div>
                    </div>
                    <div class="btn-group">
                        <button @click.prevent="openForgotPass" class="btn btn-dark btn-caps">
                            <span>{{ 'FORGOT YOUR PASSWORD?' | translate }}</span>
                        </button>
                        <button class="btn btn-primary btn-caps">
                            <span>{{ 'Login' | translate | normalize }}</span>
                        </button>
                        <div v-if="error_all" class="error-msg-con multiple">
                            <span><i class="fa fa-exclamation-triangle"></i>{{ 'Login failed' | translate }}</span>
                            <p>{{ 'Username or password is incorrect' | translate }}</p>
                        </div>

                        <template v-if="oauthProviders.length">
                            <p class="divider">{{ 'OR' | translate }}</p>
                            <button :class="`btn btn-${provider}-oauth`" @click.prevent="redirectOauth(provider)" v-for="provider in oauthProviders" :key="provider">
                                <i :class="`icon icon-${provider}`"></i>
                                <span class="icon-bg"></span>
                                <span>{{ `Connect with ${capitalize(provider)}` | translate }}</span>
                            </button>
                            <div v-if="hasProviderError" :class="`error-msg-con ${provider}-connect`">
                                <i class="fa fa-exclamation-triangle"></i>{{ 'This email address is not registered, please sign up to log in.' | translate }}
                            </div>
                        </template>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Default from '@views/public/layouts/Default'
    import Login from '@views/public/pages/Login/login'

    export default {
        mixins: [Login],
        components: {
            Default
        },
        computed: {
            hasProviderError() {
                return this.error_google_connect || this.error_yahoo_connect || this.error_apple_connect || this.error_microsoft_connect
            }
        }
    }
</script>

<style lang="scss" src="./login.scss"></style>
